<template>
  <BaseLoginPage></BaseLoginPage>
</template>

<script>
import { mapGetters } from 'vuex';

//BaseLoginPage select in nuxt config in section [components by brand]
import BaseLoginPage from '@baseLoginPage';
import appCommonMixin from '@/components/mixins/appCommonMixin';

export default {
  name: 'LoginPageComponent',
  components: {
    BaseLoginPage
  },
  mixins: [appCommonMixin],
  data() {
    return {
      bodyClassList: this.$store.getters[
        'ContextStore/getPlatformBodyClassList'
      ]
    };
  },
  head() {
    return {
      bodyAttrs: {
        class: [...this.bodyClassList]
      }
    };
  },
  computed: {
    ...mapGetters('ContextStore', ['isRegistrationAllowed', 'isDevice'])
  },
  mounted() {
    this.addGuestClass();
  },
  destroyed() {
    this.removeGuestClass();
  }
};
</script>

<style lang="less" src="./LoginPage.less"></style>
